import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import leftArrow from '../../assets/img/white-left-icon.svg';
import Header from '../../components/Header';
import SelectTemplate from './overviewtabs/SelectTemplate';
import { useAuth } from '../../contexts/AuthContext';

function TemplatesLibrary() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const backUrl = location.state?.backUrl || `/`;
  const [templateId, setTemplateId] = useState('');
  const [companyId, seCompanyId] = useState('');
  const [backscreenUrl, setbackscreenUrl] = useState('/');

  useEffect(() => {
    if (user) {
      seCompanyId(user?.companyId?._id);
    }
    if (backUrl) {
      setbackscreenUrl(backUrl);
    }
  }, [user, backUrl]);
  const HeaderContent = (
    <>
      <h2>Template Library</h2>
      <div className="head-right">
        <a onClick={() => navigate(backscreenUrl)}>
          <img src={leftArrow} alt="comp1" className="left-arrow" />
        </a>
      </div>
    </>
  );

  return (
    <div className="wrapper create_project">
      <Header content={HeaderContent} />
      <div className="main-content">
        <SelectTemplate setTemplateId={setTemplateId} companyId={companyId} isLibrary={true} backUrl={backUrl} />
      </div>
    </div>
  );
}

export default TemplatesLibrary;
